<template>
    <b-tab 
        v-show="visible"
        :active="active" 
        :button-id="buttonId" 
        :disabled="disabled" 
        :lazy="lazy" 
        :no-body="noBody" 
        :tag="tag" 
        :title="visible ? $storage.getTextoTraduzido(title) : ''" 
        :style="visible ? style : 'visibility:hidden'" 
        :title-item-class="visible ? titleItemClass : 'd-none'" 
        :title-link-attributes="titleLinkAttributes" 
        :title-link-class="titleLinkClass"
        @click="click"
    >
        <!-- Título com ícone (opt-in via iconName). Sem ícone, o b-tab usa a prop title como antes. -->
        <template v-if="visible && iconName" #title>
            <span class="clic-tab-title">
                <ClicIconInterno :cp="cp" :state="state" />
                <span>{{ $storage.getTextoTraduzido(title) }}</span>
            </span>
        </template>

        <MotorS 
            :cp="cp" 
            :childrens="childrens"
            :idTela="idTela"
        />
   </b-tab>
</template>

<script>

import ComponentMixin from '../../core/ComponentMixin';
import { BTab } from 'bootstrap-vue';

export default {
    name: 'ClicTab',
    mixins: [ComponentMixin],
    components: { BTab },
    
    methods: {

        click (event) {
            let eventoClick = this.lodash.get(this.cp, 'events.click');
            if  (eventoClick) {
                this._execEvent('click', { event });
            }
        },

    }
};
</script>

<style>
    .clic-tab-title {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        white-space: nowrap;
    }
</style>
